import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import partition from 'lodash/partition'
import some from 'lodash/some'
import PageSection from '../../../shared/components/layouts/PageSection'
import NetworkInterfaceCard from './NetworkInterfaceCard'

function NodeNetworkTab({ networkInterfaces = [] }) {
  const [publicInterfaces, privateInterfaces] = useMemo(() => {
    return partition(networkInterfaces, (iface) =>
      some(iface.addresses, (addr) => addr.isPublic)
    )
  }, [networkInterfaces])

  if (networkInterfaces.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="text.secondary">
          <FormattedMessage id="nodes.network.empty" />
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {publicInterfaces.length > 0 && (
        <PageSection titleId="nodes.sections.publicInterfaces">
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
            {publicInterfaces.map((iface) => (
              <NetworkInterfaceCard key={iface.id} networkInterface={iface} />
            ))}
          </Box>
        </PageSection>
      )}

      {privateInterfaces.length > 0 && (
        <PageSection titleId="nodes.sections.privateInterfaces">
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
            {privateInterfaces.map((iface) => (
              <NetworkInterfaceCard key={iface.id} networkInterface={iface} />
            ))}
          </Box>
        </PageSection>
      )}
    </Box>
  )
}

export default NodeNetworkTab
